import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'simplemde-container', // tslint:disable-line:component-selector
  template: `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    '../../../../node_modules/simplemde/dist/simplemde.min.css'
  ]
})
export class SimpleMDEComponent {
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/simple-mde/simple-mde.component.ts